import { NavLink, Outlet } from 'react-router-dom';
import { Send, Users, FileText, LayoutTemplate, ShieldOff } from 'lucide-react';
import { SectionHeader } from '@/components/ui/Card';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/newsletter/campaigns',    label: 'Campaigns',    icon: Send },
  { to: '/newsletter/subscribers',  label: 'Subscribers',  icon: Users },
  { to: '/newsletter/audiences',    label: 'Audiences',    icon: LayoutTemplate },
  { to: '/newsletter/templates',    label: 'Templates',    icon: FileText },
  { to: '/newsletter/suppressions', label: 'Suppressions', icon: ShieldOff },
];

export function NewsletterLayout() {
  return (
    <div className="space-y-8">
      <SectionHeader
        kicker="Newsletter · Marketing"
        title="Reach every customer."
        description="Branded email campaigns to clients and subscribers — with segmentation, scheduling, and full delivery analytics via AWS SES."
      />

      <div className="border-b border-border overflow-x-auto -mx-8 px-8">
        <nav className="flex gap-1 -mb-px">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'inline-flex items-center gap-2.5 px-5 h-11 text-xs uppercase tracking-[0.15em] transition-colors border-b-2 whitespace-nowrap',
                    isActive
                      ? 'border-brass-400 text-text'
                      : 'border-transparent text-text-muted hover:text-text',
                  )
                }
              >
                <Icon size={13} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <div><Outlet /></div>
    </div>
  );
}
